import React, { useEffect, useState, } from 'react';
import { Link, } from 'react-router-dom';

import Swal from 'sweetalert2';
import axios from 'axios';
import $ from 'jquery';

import useAuth from '../../controllers/users/useAuth';
import BuildingHeader from '../buildings/BuildingHeader';

import { taxModelGet } from '../../models/taxes/tax';

import {
    checkIfUserIsMaster, dataTableLanguaje, responseGet, globalSettings, styles, sendMessageCloseCurrentWindowAsync, buttonProcessGet, separatorsNumbersSet, awaitDelay,
    dateTimeFormatGlobalSet, processEvaluateGet, languageObjGet, isUndNullEmp, LoadingSection,
} from '../../helpers/settings';
import TaxAddDetailsEdit from './TaxAddDetailsEdit';
import Menu from '../main/Menu';
import { buildingsByUserGetAsync } from '../../controllers/apartments/apartmentUsers';
import { GlobalFormats } from '../../classes/main/globalFormats';
import { buildingModelGet } from '../../models/buildings/building';

const currentMethod = 'Taxes';

const { app, collections: dbColle, colors, icons, labels, messages, react, } = globalSettings;
const { backend, } = app;
const { properties: dbProps, } = dbColle;
const { operators: dbOpera, } = react?.firebase;
const { html: reactHtml, sweetAlert2, tempusDominus, } = react;

export default function Taxes({
    languageObj = GlobalFormats?.class(languageObjGet({ subMethod: currentMethod, })?.result),
}) {
    //#region variables
    let result;
    let dataObj = {};
    let headerObj = {};
    const auth = useAuth();
    //const history = useHistory();
    const userRole = checkIfUserIsMaster({ email: auth?.user?.email || '', languageId: languageObj?.id, subMethod: currentMethod })?.result;
    const [showModal, setShowModal] = useState(false);
    //const [showData, setShowData] = useState(false);
    const [showLoading, setShowLoading] = useState({ building: true, taxes: true, });
    const [btnAddDisable, setBtnAddDisable] = useState(true);
    //#endregion variables

    //#region taxes
    const dtTaxesId = 'dtPurchases';
    const [dtTaxesRowIndex, setDtTaxesRowIndex] = useState(0);
    const [tax, setTax] = useState(taxModelGet({}));
    const [processType, setProcessType] = useState(-1);
    const [btnSyncDisabled, setBtnSyncDisabled] = useState(true);
    //#endregion taxes

    //#region buildings
    const buildingsId = 'buildings';
    const [buildings, setBuildings] = useState([buildingModelGet({})]);
    const [building, setBuilding] = useState(buildingModelGet({}));
    //#endregion buildings

    //#region others
    const controls = {
        buttons: {
            // save: {
            //     id: 'btnCreate',
            //     className: 'btn btn-outline-warning mx-1',
            // },
            // back: {
            //     id: 'btnBack',
            //     className: '',
            // },
            // close: {
            //     id: 'btnClose',
            //     className: 'close btn-danger fas fa-window-close',
            // },
        },
        checkBox: {
            // remenberMe: {
            //     attributes: {
            //     },
            //     id: 'chkRemenberMe',
            // },
        },
        dataTables: {
            taxes: {
                buttons: {
                    add: {
                        className: 'btn btn-outline-success float-right btn-sm',
                        id: 'btndtTaxesIdAdd',
                    },
                    delete: {
                        className: 'btn btn-outline-danger float-right btn-sm mx-1',
                        id: 'btndtTaxesIdDelete',
                    },
                },
                icons: {
                    add: {
                        id: 'icondtTaxesIdAdd',
                        className: icons?.plusCircle,
                    },
                    delete: {
                        id: 'icondtTaxesIdDelete',
                        className: icons?.trash,
                    },
                },
                inputs: {
                    search: {
                        id: `${dtTaxesId}_filter input`,
                        className: '',
                    },
                },
                selects: {
                    entries: {
                        id: `${dtTaxesId}_length select`,
                        className: '',
                    },
                },
                spinners: {
                    add: {
                        id: 'spdtTaxesIdAdd',
                        className: '',
                    },
                    delete: {
                        id: 'spdtTaxesIdDelete',
                        className: '',
                    },
                },
            },
        },
        icons: {
            // save: {
            //     id: 'icoSave',
            //     className: icons?.save,
            // },
            // back: {
            //     id: 'icoBack',
            //     className: icons?.arrowCircleLeft,
            // },
            // close: {
            //     id: 'icoClose',
            //     className: icons?.plusCircle,
            // },
        },
        inputs: {
            // user: {
            //     id: 'inputUser',
            //     className: 'form-control bg-transparent',
            // },
            // title: {
            //     id: 'inputTitle',
            //     className: 'form-control bg-transparent',
            // },
            // comment: {
            //     id: 'inputComment',
            //     className: 'form-control',
            // },
            // statusComment: {
            //     id: 'inputStatusComment',
            //     className: 'form-control bg-transparent text-black',
            // },
        },
        selects: {
            // apartment: {
            //     id: 'selApartmet',
            //     className: 'form-select',
            // },
            // title: {
            //     id: 'selTitle',
            //     className: 'form-select',
            // },
            // icon: {
            //     id: 'selIcon',
            //     className: 'form-select',
            // },
            // status: {
            //     id: 'selStatus',
            //     className: 'form-select',
            // },
        },
        spinners: {
            // save: {
            //     id: 'spSave',
            //     className: '',
            // },
            // back: {
            //     id: 'spBack',
            //     className: '',
            // },
        },
        urls: {
            // forgotYourPassword: {
            //     id: 'urlForgotYourPassword',
            //     className: 'btn-link',
            // },
            // reCaptchaPrivaciConditions: {
            //     id: 'urlReCaptchaPrivaciConditions',
            //     className: '',
            // },
            // userRegister: {
            //     id: 'urlRequestAccount',
            //     className: '',
            // },
            // registerStatus: {
            //     id: 'urlStatusRegister',
            //     className: '',
            // },
        },
    };
    //#endregion others

    //#region taxes (methods)
    const dataTableTaxesSet = ({
        subMethod = '',
    }) => {
        const currentMethod = 'dataTableTaxesSet';
        let response = responseGet();
        try {
            $(`#${dtTaxesId}`)?.DataTable({
                //buttons: ['copy', 'csv', 'excel', 'pdf', 'print', 'colvis',],
                columns: [
                    { title: labels?.date?.[languageObj?.id], orderable: false, searchable: false, visible: false, width: '0%', },
                    { title: labels?.date?.[languageObj?.id], orderable: false, width: '20%', },
                    { title: labels?.percentage?.[languageObj?.id], orderable: false, className: 'text-right', width: '15%', },
                    { title: labels?.remark?.[languageObj?.id], orderable: false, width: '60%', },
                    { title: labels?.process?.[languageObj?.id], className: 'text-center', orderable: false, searchable: false, width: '5%', },
                ],
                data: [],
                destroy: true,
                language: dataTableLanguaje({ languageId: languageObj?.id, subMethod: currentMethod, }),
                responsive: true,
                lengthChange: true,
                autoWidth: false,
                order: [[0, 'desc']],
                //}).buttons().container().appendTo(`#${dtTaxesId}_wrapper .col-md-6:eq(0)`);
            });
        } catch (ex) {
            response.msgType = -1;
            response.isSuccess = false;
            response.msgText = `Method: ${currentMethod}<br/>`;
            if (!isUndNullEmp({ data: subMethod, subMethod: currentMethod })?.result) {
                response.msgText += `Sub method: ${subMethod}<br/>`;
            }
            response.msgText += `Error: ${ex?.message}`;
        }
        return response;
    }

    const taxesGetAsync = async ({
        e = {},
        subMethod = '',
    }) => {
        const currentMethod = 'taxesGetAsync';
        let response = responseGet();
        try {
            //#region variables
            let dtRows = [];
            let isEditLocal = false;
            let buildingIdLocal = '';
            let isDeleteLocal = false;
            let taxesLocal = [taxModelGet({})];
            let buildingLocal = buildingModelGet({});
            //#endregion variables

            setShowLoading({ building: false, taxes: true, });

            //#region initialize
            setBuilding({});
            setProcessType(0);
            setBtnSyncDisabled(true);
            setBtnAddDisable(true);
            buildingIdLocal = $(`#${buildingsId}`)?.val();

            response = dataTableClears({
                dtTaxes: true,
                subMethod: currentMethod,
            });

            if (!response?.isSuccess || response?.isWarning) {
                setShowLoading({ building: false, taxes: false, });
                await sendMessageCloseCurrentWindowAsync({
                    msgType: response?.msgType,
                    msgText: !isUndNullEmp({ data: response?.msgHtml, subMethod: currentMethod, })?.result ? response?.msgHtml : response?.msgText,
                    closeWindow: false,
                    urlGoTo: response?.urlGoTo,
                    auth: auth,
                    isLogout: false,
                    languageId: languageObj?.id,
                    subMethod: currentMethod,
                });
                return response;
            }
            //#endregion initialize

            //#region data get (taxes)
            if (!isUndNullEmp({ data: buildingIdLocal, subMethod: currentMethod, })?.result) {
                buildingLocal = buildings?.find(({ id }) => id === buildingIdLocal) || {};
                if (!isUndNullEmp({ data: buildingLocal?.id, subMethod: currentMethod, })?.result) {
                    setBuilding(buildingLocal);
                    headerObj = {
                        headers: {
                            authorization: `bearer ${auth?.user?.tokenVzLaCondominios?.token}`,
                        },
                    };

                    dataObj = {
                        limit: 0,
                        conditionals: [
                            { field: dbProps?.buildingId, operator: dbOpera?.equalTo, value: buildingIdLocal, }
                        ],
                        ordersBy: [
                            { field: dbProps?.date, value: 'desc', }
                        ],
                        buildingId: buildingIdLocal,
                        languageId: languageObj?.id,
                        url: `${backend?.url}${backend?.urlApiV1}${backend?.urlTaxes}/`,
                    };

                    result = await axios?.post(
                        dataObj?.url,
                        dataObj,
                        headerObj,
                    );

                    response = result?.data || {};

                    if (!response?.isSuccess || response?.isWarning) {
                        setShowLoading({ building: false, taxes: false, });
                        await sendMessageCloseCurrentWindowAsync({
                            msgType: response?.msgType,
                            msgText: !isUndNullEmp({ data: response?.msgHtml, subMethod: currentMethod, })?.result ? response?.msgHtml : response?.msgText,
                            closeWindow: false,
                            urlGoTo: response?.urlGoTo,
                            auth: auth,
                            isLogout: false,
                            languageId: languageObj?.id,
                            subMethod: currentMethod,
                        });
                        return;
                    }

                    taxesLocal = response?.result || [];

                    //#region add taxes dtTable (taxes)
                    if (!isUndNullEmp({ data: taxesLocal, subMethod: currentMethod, })?.result && taxesLocal?.length > 0) {
                        taxesLocal?.forEach((detail) => {
                            //#region variables
                            dataObj = {
                                dateTimeOrder: dateTimeFormatGlobalSet({
                                    date: detail?.date,
                                    type: tempusDominus?.format?.date?.ymdTwo,
                                    format: 24,
                                    addTime: false,
                                    secondsShow: false,
                                    languageId: languageObj?.id,
                                    subMethod: currentMethod,
                                })?.result,
                                dateTime: dateTimeFormatGlobalSet({
                                    date: detail?.date,
                                    type: languageObj.format?.date?.f1,
                                    format: 0,
                                    addTime: false,
                                    secondsShow: false,
                                    languageId: languageObj?.id,
                                    subMethod: currentMethod,
                                })?.result,
                                percentage: separatorsNumbersSet({
                                    number: detail?.percentage,
                                    withDecimals: true,
                                    consoleLogErrorShow: true,
                                    subMethod: currentMethod,
                                })?.result,
                                remark: detail?.remark,
                            };
                            //#endregion variables

                            //#region methods
                            dtRows.push([
                                dataObj?.dateTimeOrder,
                                dataObj?.dateTime,
                                dataObj?.percentage,
                                dataObj?.remark,
                                buttonProcessGet({
                                    id: detail.id,
                                    //description: dataObj?.percentage,
                                    description: `${dataObj?.remark}§${dataObj?.percentage}`,
                                    showDetails: true,
                                    labelDetails: labels?.detail?.[languageObj?.id],
                                    enabledDetails: true,
                                    showEdit: true,
                                    labelEdit: labels?.edit?.[languageObj?.id],
                                    enabledEdit: processEvaluateGet({
                                        object: detail,
                                        property: labels?.process?.en?.toLowerCase(),
                                        process: labels?.edit?.en?.toLowerCase(),
                                        subMethod: currentMethod,
                                    })?.result,
                                    showDelete: true,
                                    labelDelete: labels?.delete?.[languageObj?.id],
                                    enabledDelete: processEvaluateGet({
                                        object: detail,
                                        property: labels?.process?.en?.toLowerCase(),
                                        process: labels?.delete?.en?.toLowerCase(),
                                        subMethod: currentMethod,
                                    })?.result,
                                    processButtons: [],
                                    subMethod: currentMethod,
                                })?.result,
                            ]);
                            //#endregion methods
                        });
                    }

                    //#region set edit, delete
                    isEditLocal = processEvaluateGet({
                        object: buildingLocal,
                        property: labels?.process?.en?.toLowerCase(),
                        process: labels?.edit?.en?.toLowerCase(),
                        subMethod: currentMethod,
                    })?.result;
                    //#region old code
                    // localIsDelete = processEvaluateGet(
                    //     localBuilding,
                    //     labels?.process?.en?.toLowerCase(),
                    //     labels?.delete?.en?.toLowerCase(),
                    //     localSubmethodName
                    // ).result;
                    //#endregion old code
                    isDeleteLocal = isEditLocal;

                    setBtnAddDisable(!(isEditLocal && isDeleteLocal));
                    //#endregion set edit, delete

                    setBtnAddDisable(false);
                    setBtnSyncDisabled(false);
                    //#endregion add taxes dtTable (taxes)
                }
            }
            //#endregion data get (taxes)

            //#region dataTable set
            $(`#${dtTaxesId}`)?.DataTable()?.rows?.add(dtRows)?.draw(true);
            //#endregion dataTable set

            setShowLoading({ building: false, taxes: false, });
        } catch (ex) {
            setShowLoading({ building: false, taxes: false, });
            response.msgType = -1;
            response.isSuccess = false;
            response.msgText = `Method: ${currentMethod}<br/>`;
            if (!isUndNullEmp({ data: subMethod, subMethod: currentMethod })?.result) {
                response.msgText += `Sub method: ${subMethod}<br/>`;
            }
            response.msgText += `Error: ${ex?.message}`;
            await sendMessageCloseCurrentWindowAsync({
                msgType: response?.msgType,
                msgText: !isUndNullEmp({ data: response?.msgHtml, subMethod: currentMethod, })?.result ? response?.msgHtml : response?.msgText,
                closeWindow: false,
                urlGoTo: response?.urlGoTo,
                auth: auth,
                isLogout: false,
                languageId: languageObj?.id,
                subMethod: currentMethod,
            });
        }
    }

    const taxAddDetailsEditGetAsync = async ({
        e = {},
        id = '',
        description = '',
        rowIndex = '',
        processType = 0,
        subMethod = '',
    }) => {
        let response = responseGet();
        try {
            if (!isUndNullEmp({ data: e, subMethod: currentMethod, })?.result) {
                e?.preventDefault();
            }

            //#region variables
            let taxLocal = taxModelGet({});
            const buildingIdLocal = $(`#${buildingsId}`)?.val();
            //#endregion variables

            //#region building validate
            if (isUndNullEmp({ data: buildingIdLocal, subMethod: currentMethod, })?.result) {
                await sendMessageCloseCurrentWindowAsync({
                    msgType: 1,
                    msgText: messages?.youMustSelectBuilding?.[languageObj?.id],
                    closeWindow: false,
                    urlGoTo: response?.urlGoTo,
                    auth: auth,
                    isLogout: false,
                    languageId: languageObj?.id,
                    subMethod: currentMethod,
                });
                return
            }
            //#endregion building validate

            if (processType === 0) {
                controlsStatusSet({ processType: 1, subMethod: currentMethod, });
            } else {
                setShowLoading({ building: false, taxes: true, });
            }

            //#region data get (tax)
            if (processType === 0) {
                taxLocal = taxModelGet({
                    buildingId: buildingIdLocal,
                    userId: auth?.user?.uid,
                });
            } else {
                headerObj = {
                    headers: {
                        authorization: `bearer ${auth?.user?.tokenVzLaCondominios?.token}`,
                        languageId: languageObj?.id,
                    },
                    url: `${backend?.url}${backend?.urlApiV1}${backend?.urlTaxes}/${id}`,
                };

                result = await axios?.get(
                    headerObj?.url,
                    headerObj,
                );

                response = result?.data || {};

                if (!response?.isSuccess || response?.isWarning) {
                    if (processType === 0) {
                        controlsStatusSet({ processType: 0, subMethod: currentMethod, });
                    } else {
                        setShowLoading({ building: false, taxes: false, });
                    }
                    await sendMessageCloseCurrentWindowAsync({
                        msgType: response?.msgType,
                        msgText: !isUndNullEmp({ data: response?.msgHtml, subMethod: currentMethod, })?.result ? response?.msgHtml : response?.msgText,
                        closeWindow: false,
                        urlGoTo: response?.urlGoTo,
                        auth: auth,
                        isLogout: false,
                        languageId: languageObj?.id,
                        subMethod: currentMethod,
                    });
                    return;
                }
                //setTax(response.result);
                taxLocal = response.result;
            }

            //#endregion data get (tax)

            setTax(taxLocal);
            setProcessType(processType);
            setDtTaxesRowIndex(rowIndex);

            if (processType === 0) {
                await awaitDelay({ delayTimer: globalSettings?.timers?.threeNanoSeconds, });
            }

            setShowModal(true);

            if (processType === 0) {
                controlsStatusSet({ processType: 0, subMethod: currentMethod, });
            } else {
                setShowLoading({ building: false, taxes: false, });
            }
        } catch (ex) {
            if (processType === 0) {
                controlsStatusSet({ processType: 0, subMethod: currentMethod, });
            } else {
                setShowLoading({ building: false, taxes: false, });
            }
            response.msgType = -1;
            response.isSuccess = false;
            response.msgText = `Method: ${currentMethod}<br/>`;
            if (!isUndNullEmp({ data: subMethod, subMethod: currentMethod })?.result) {
                response.msgText += `Sub method: ${subMethod}<br/>`;
            }
            response.msgText += `Error: ${ex?.message}`;
            await sendMessageCloseCurrentWindowAsync({
                msgType: response?.msgType,
                msgText: !isUndNullEmp({ data: response?.msgHtml, subMethod: currentMethod, })?.result ? response?.msgHtml : response?.msgText,
                closeWindow: false,
                urlGoTo: response?.urlGoTo,
                auth: auth,
                isLogout: false,
                languageId: languageObj?.id,
                subMethod: currentMethod,
            });
        }
    }

    const taxDeleteAsync = async ({
        id = '',
        description = '',
        rowIndex = 0,
        subMethod = '',
    }) => {
        const currentMethod = 'taxDeleteAsync';
        let response = responseGet();
        try {
            //#region show message
            const index1 = description?.indexOf('§');
            const index2 = description?.length;
            const remark = description?.slice(0, index1)?.trim();
            const percentage = description?.slice(index1 + 1, index2)?.trim();

            let msgTextObj = {
                //one: `${labels?.tax?.[languageObj?.id]}<br/>`,
                one: `${labels?.remark?.[languageObj?.id]}: <b>${remark}</b><br/>`,
                two: `${labels?.percentage?.[languageObj?.id]}: <b>${percentage}</b><br/>`,
                three: `${messages?.thisProcessIrreversibleDoYouWishContinue?.[languageObj?.id]}`,
            };

            let swalProperties = {
                icon: sweetAlert2?.icons?.warning,
                title: messages?.areYouSureDeleteThis?.[languageObj?.id],
                html: `${msgTextObj?.one}${msgTextObj?.two}${msgTextObj?.three}`,
                timer: null,
                backdrop: true,
                confirmButtonColor: colors?.warningColorExp,
                confirmButtonText: labels?.yes?.[languageObj?.id],
                showCancelButton: true, //!Swal.isLoading(), //true,
                cancelButtonColor: colors?.successColorExp,
                cancelButtonText: labels?.no?.[languageObj?.id],
                showLoaderOnConfirm: true,
                didOpen: () => {
                    Swal.hideLoading();
                },
                preConfirm: async () => {
                    try {
                        Swal.getCancelButton().hidden = true;
                        Swal?.update({
                            icon: sweetAlert2?.icons?.info,
                            title: `${messages?.processing?.[languageObj?.id]}...`,
                            html: `${msgTextObj?.one}${msgTextObj?.two}`,
                            showConfirmButton: false,
                        });

                        //#region delete tax
                        headerObj = {
                            headers: {
                                languageCode: languageObj?.code,
                                languageId: languageObj?.id,
                                authorization: `bearer ${auth?.user?.tokenVzLaCondominios?.token}`,
                            },
                            url: `${backend?.url}${backend?.urlApiV1}${backend?.urlTaxes}/${id}`
                        };

                        result = await axios.delete(
                            headerObj?.url,
                            headerObj,
                        );

                        response = result?.data || {};

                        if (!response?.isSuccess || response?.isWarning) {
                            await sendMessageCloseCurrentWindowAsync({
                                msgType: response?.msgType,
                                msgText: !isUndNullEmp({ data: response?.msgHtml, subMethod: currentMethod, })?.result ? response?.msgHtml : response?.msgText,
                                closeWindow: false,
                                urlGoTo: response?.urlGoTo,
                                auth: auth,
                                isLogout: false,
                                languageId: languageObj?.id,
                                subMethod: currentMethod,
                            });
                            return;
                        }
                        //#endregion delete tax

                        //#region delete tax (dataTable)
                        $(`#${dtTaxesId}`)?.DataTable()?.row(rowIndex)?.remove()?.draw(true);
                        //#endregion delete tax (dataTable)

                        //#region data set
                        setTax({});
                        setDtTaxesRowIndex(0);
                        //#endregion data set

                        await sendMessageCloseCurrentWindowAsync({
                            msgType: 0,
                            msgText: `${messages?.processesCompletedSuccessfully?.[languageObj?.id]}.`,
                            closeWindow: false,
                            urlGoTo: response?.urlGoTo,
                            auth: auth,
                            isLogout: false,
                            languageId: languageObj?.id,
                            subMethod: currentMethod,
                        });
                    } catch (ex) {
                        //#region Error
                        response.isSuccess = false;
                        response.msgType = -1;
                        response.msgText = `Method: ${currentMethod}<br/>`;
                        response.msgText += `Error: ${ex?.message}`;
                        await sendMessageCloseCurrentWindowAsync({
                            msgType: response?.msgType,
                            msgText: response?.msgText,
                            closeWindow: false,
                            urlGoTo: response?.urlGoTo,
                            auth: auth,
                            isLogout: false,
                            languageId: languageObj?.id,
                        });
                        //#endregion Error
                    }
                },
                allowOutsideClick: () => !Swal.isLoading(),
            };

            await Swal.fire(swalProperties);
            //#endregion show message   
        } catch (ex) {
            setShowLoading({ building: false, coins: false, });
            response.msgType = -1;
            response.isSuccess = false;
            response.msgText = `Method: ${currentMethod}<br/>`;
            if (!isUndNullEmp({ data: subMethod, subMethod: currentMethod })?.result) {
                response.msgText += `Sub method: ${subMethod}<br/>`;
            }
            response.msgText += `Error: ${ex?.message}`;
            await sendMessageCloseCurrentWindowAsync({
                msgType: response?.msgType,
                msgText: !isUndNullEmp({ data: response?.msgHtml, subMethod: currentMethod, })?.result ? response?.msgHtml : response?.msgText,
                closeWindow: false,
                urlGoTo: response?.urlGoTo,
                auth: auth,
                isLogout: false,
                languageId: languageObj?.id,
                subMethod: currentMethod,
            });
        }
    }
    //#endregion taxes (methods)

    //#region methods (others)
    const dataGetAsync = async ({
        subMethod = '',
    }) => {
        const currentMethod = 'dataGetAsync';
        let response = responseGet();
        try {
            setShowLoading({ building: true, taxes: true, });

            //#region dataTable set
            response = dataTablesSet({
                subMethod: '',
            });

            if (!response?.isSuccess || response?.isWarning) {
                setShowLoading({ building: false, taxes: false, });
                await sendMessageCloseCurrentWindowAsync({
                    msgType: response?.msgType,
                    msgText: !isUndNullEmp({ data: response?.msgHtml, subMethod: currentMethod, })?.result ? response?.msgHtml : response?.msgText,
                    closeWindow: false,
                    urlGoTo: response?.urlGoTo,
                    auth: auth,
                    isLogout: false,
                    languageId: languageObj?.id,
                    subMethod: currentMethod,
                });
                return;
            }

            response = dataTableClears({
                dtTaxes: true,
                subMethod: currentMethod,
            });

            if (!response?.isSuccess || response?.isWarning) {
                setShowLoading({ building: false, taxes: false, });
                await sendMessageCloseCurrentWindowAsync({
                    msgType: response?.msgType,
                    msgText: !isUndNullEmp({ data: response?.msgHtml, subMethod: currentMethod, })?.result ? response?.msgHtml : response?.msgText,
                    closeWindow: false,
                    urlGoTo: response?.urlGoTo,
                    auth: auth,
                    isLogout: false,
                    languageId: languageObj?.id,
                    subMethod: currentMethod,
                });
                return response;
            }
            //#endregion dataTable set

            //#region buildings get
            response = await buildingsByUserGetAsync({
                userRole: userRole,
                auth: auth,
                urlGoTo: backend?.urlTaxes,
                languageId: languageObj?.id,
                subMethod: currentMethod,
            });

            if (!response?.isSuccess || response?.isWarning) {
                setShowLoading({ building: false, taxes: false, });
                await sendMessageCloseCurrentWindowAsync({
                    msgType: response?.msgType,
                    msgText: !isUndNullEmp({ data: response?.msgHtml, subMethod: currentMethod, })?.result ? response?.msgHtml : response?.msgText,
                    closeWindow: false,
                    urlGoTo: response?.urlGoTo,
                    auth: auth,
                    isLogout: false,
                    languageId: languageObj?.id,
                    subMethod: currentMethod,
                });
                return;
            }

            if (!isUndNullEmp({ data: response?.result?.buildings, subMethod: currentMethod, })?.result && response?.result?.buildings?.length > 0) {
                setBuildings(response.result.buildings);
            }
            //#endregion buildings get

            setShowLoading({ building: false, taxes: false, });
        } catch (ex) {

            setShowLoading({ building: false, taxes: false, });
            response.msgType = -1;
            response.isSuccess = false;
            response.msgText = `Method: ${currentMethod}<br/>`;
            if (!isUndNullEmp({ data: subMethod, subMethod: currentMethod })?.result) {
                response.msgText += `Sub method: ${subMethod}<br/>`;
            }
            response.msgText += `Error: ${ex?.message}`;
            await sendMessageCloseCurrentWindowAsync({
                msgType: response?.msgType,
                msgText: !isUndNullEmp({ data: response?.msgHtml, subMethod: currentMethod, })?.result ? response?.msgHtml : response?.msgText,
                closeWindow: false,
                urlGoTo: response?.urlGoTo,
                auth: auth,
                isLogout: false,
                languageId: languageObj?.id,
                subMethod: currentMethod,
            });
        }
    }

    const dataTablesSet = ({
        subMethod = '',
    }) => {
        const currentMethod = 'dataTablesSet';
        let response = responseGet();
        try {
            response = dataTableTaxesSet({
                subMethod: currentMethod,
            });

            if (!response?.isSuccess || response?.isWarning) {
                return response;
            }

            response = queryCodeSet({
                subMethod: currentMethod,
            });

            if (!response?.isSuccess || response?.isWarning) {
                return response;
            }
        } catch (ex) {
            response.msgType = -1;
            response.isSuccess = false;
            response.msgText = `Method: ${currentMethod}<br/>`;
            if (!isUndNullEmp({ data: subMethod, subMethod: currentMethod })?.result) {
                response.msgText += `Sub method: ${subMethod}<br/>`;
            }
            response.msgText += `Error: ${ex?.message}`;
        }
        return response;
    }

    const queryCodeSet = ({
        subMethod = '',
    }) => {
        const currentMethod = 'queryCodeSet';
        let response = responseGet();
        try {
            //#region variables
            let id = '';
            let method = '';
            let rowIndex = 0;
            let dtRowIndex = 0;
            let description = '';
            //#endregion variables

            //#region collection cashes
            $(`#${dtTaxesId} tbody`)?.on('click', 'tr', 'td', function (e) {
                e?.preventDefault();
                rowIndex = $(`#${dtTaxesId}`)?.DataTable()?.row(this)?.index();
                dtRowIndex = !isUndNullEmp({ data: rowIndex, subMethod: currentMethod, })?.result ? rowIndex : dtRowIndex;
                if (!isUndNullEmp({ data: dtRowIndex, subMethod: currentMethod, })?.result) {
                    id = e?.target?.attributes?.id?.value || '';
                    method = e?.target?.attributes?.method?.value || '';
                    description = e?.target?.attributes?.description?.value || '';
                    switch (method) {
                        case 'details':
                            taxAddDetailsEditGetAsync({ e: e, id: id, description: description, rowIndex: dtRowIndex, processType: 2, subMethod: currentMethod, });
                            break;
                        case 'edit':
                            taxAddDetailsEditGetAsync({ e: e, id: id, description: description, rowIndex: dtRowIndex, processType: 1, subMethod: currentMethod, });
                            break;
                        case 'delete':
                            taxDeleteAsync({ e: e, id: id, description: description, rowIndex: dtRowIndex, subMethod: currentMethod, });
                            break;
                        default:
                            break;
                    }
                }
            });
            //#endregion collection cashes
        } catch (ex) {
            response.msgType = -1;
            response.isSuccess = false;
            response.msgText = `Method: ${currentMethod}<br/>`;
            if (!isUndNullEmp({ data: subMethod, subMethod: currentMethod })?.result) {
                response.msgText += `Sub method: ${subMethod}<br/>`;
            }
            response.msgText += `Error: ${ex?.message}`;
        }
        return response;
    }

    const dataTableClears = ({
        dtTaxes = false,
        subMethod = '',
    }) => {
        const currentMethod = 'dataTableClears';
        let response = responseGet();
        try {
            if (dtTaxes) {
                $(`#${dtTaxesId}`)?.DataTable()?.rows()?.clear()?.draw(true);
            }
        } catch (ex) {
            response.msgType = -1;
            response.isSuccess = false;
            response.msgText = `Method: ${currentMethod}<br/>`;
            if (!isUndNullEmp({ data: subMethod, subMethod: currentMethod })?.result) {
                response.msgText += `Sub method: ${subMethod}<br/>`;
            }
            response.msgText += `Error: ${ex?.message}`;
        }
        return response;
    }

    const controlsStatusSet = ({
        processType = 0,
        subMethod = '',
    }) => {
        let response = responseGet();
        const currentMethod = 'controlsStatusSet';
        try {
            //#region variables
            //#endregion variables

            //#region methods
            switch (processType) {
                case 0:
                    $(`#${controls?.dataTables?.taxes?.icons?.add?.id}`)?.removeClass();
                    $(`#${controls?.dataTables?.taxes?.buttons?.add?.id}`)?.removeClass();
                    $(`#${controls?.dataTables?.taxes?.spinners?.add?.id}`)?.removeClass();

                    $(`#${controls?.dataTables?.taxes?.icons?.add?.id}`)?.addClass(controls?.dataTables?.taxes?.icons?.add?.className);
                    $(`#${controls?.dataTables?.taxes?.buttons?.add?.id}`)?.addClass(controls?.dataTables?.taxes?.buttons?.add?.className);
                    $(`#${controls?.dataTables?.taxes?.spinners?.add?.id}`)?.addClass(controls?.dataTables?.taxes?.spinners?.add?.className);
                    break;
                case 1:
                    //$(`#${controls?.buttons?.create?.id}`)?.addClass(`${reactHtml?.button?.classes?.disabled} ${settings.react.html.button.classes.progress}`);
                    $(`#${controls?.dataTables?.taxes?.icons?.add?.id}`)?.removeClass();
                    $(`#${controls?.dataTables?.taxes?.spinners?.add?.id}`)?.addClass(`${reactHtml?.spinner?.borderSm}`);
                    break;
                default:
                    break;
            }

            //#region old code
            // $(`#${controls?.inputs?.email?.id}`).attr('readOnly', (processType !== 0));
            // $(`#${controls?.inputs?.password?.id}`).attr('readOnly', (processType !== 0));
            // $(`#${controls?.checkBox?.remenberMe?.id}`).attr('disabled', (processType !== 0));
            //#endregion old code

            //#region old code
            // $(`#${controls?.urls?.forgotYourPassword?.id}`).attr('href', (processType !== 0 ? urlStop : globalSettings?.app?.backend?.urlForgotPassword));
            // $(`#${controls?.urls?.userRegister?.id}`).attr('href', (processType !== 0 ? urlStop : globalSettings?.app?.backend?.urlUserRegister));
            // $(`#${controls?.urls?.registerStatus?.id}`).attr('href', (processType !== 0 ? urlStop : globalSettings?.app?.backend?.urlRegisterStatus));
            //#endregion old code

            //#region old code
            // $(`#${controls?.urls?.reCaptchaPrivaciConditions?.id}`).attr('href', (processType !== 0 ? urlStop : globalSettings?.react?.reCAPTCHA?.urlPrivaciConditions));
            // $(`#${controls?.urls?.reCaptchaPrivaciConditions?.id}`).attr('target', (processType !== 0 ? '' : '_blank'));
            //#endregion old code

            //#region old code
            // $(`#${controls?.urls?.reCaptchaPrivaciConditions?.id}`).attr({
            //     'href': (processType !== 0 ? urlStop : globalSettings?.app?.reCAPTCHA?.urlPrivaciConditions),
            //     'target': (processType !== 0 ? '' : '_blank'),
            // });
            //#endregion old code

            //#region dataTable buttons
            // btnExcel.node.disabled = processType !== 0;
            // btnPdf.node.disabled = processType !== 0;
            //#endregion dataTable buttons

            $(`#${controls?.dataTables?.taxes?.inputs?.search?.id}`)?.attr('readOnly', (processType !== 0));
            $(`#${controls?.dataTables?.taxes?.selects?.entries?.id}`)?.attr('disabled', (processType !== 0));

            if (processType !== 0) {
                $(`#${controls?.dataTables?.taxes?.buttons?.add?.id}`)?.addClass(`${reactHtml?.button?.classes?.disabled}`);
                $(`#${controls?.dataTables?.taxes?.buttons?.delete?.id}`)?.addClass(`${reactHtml?.button?.classes?.disabled}`);
            }
            //#endregion methods
        } catch (ex) {
            response.msgType = -1;
            response.isSuccess = false;
            response.msgText = `Method: ${currentMethod}<br/>`;
            if (!isUndNullEmp({ data: subMethod, subMethod: currentMethod })?.result) {
                response.msgText += `Sub method: ${subMethod}<br/>`;
            }
            response.msgText += `Error: ${ex?.message}<br/>`;
            console?.error(response);
        }
        return response;
    }

    useEffect(() => {
        dataGetAsync({
            subMethod: 'form - onLoad',
        });
    }, [auth]) //eslint-disable-line react-hooks/exhaustive-deps
    //#endregion methods (others)

    return (
        <div>
            <Menu viewName='settings' process='taxes' />

            <div className='content-wrapper'>

                {/* Content Header (Page header) */}
                <div className='content-header'>
                    <div className='container-fluid'>
                        <div className='row mb-2'>
                            <div className='col-sm-6'>
                                <h6 className='m-0'>{labels?.taxes?.[languageObj?.id]}</h6>
                            </div>{/* /.col */}
                            <div className='col-sm-6'>
                                <ol className='breadcrumb float-sm-right'>
                                    <li className='breadcrumb-item'><Link to='/'>{labels?.home?.[languageObj?.id]}</Link></li>
                                    <li className='breadcrumb-item active'>{labels?.taxes?.[languageObj?.id]}</li>
                                </ol>
                            </div>{/* /.col */}
                        </div>{/* /.row */}
                    </div>{/* /.container-fluid */}
                </div>
                {/* /.content-header */}

                {/* Main content */}
                <section className='content'>
                    <div className='container-fluid'>

                        <div className='row'>
                            <div className='col-12'>

                                {/*buildings*/}
                                <BuildingHeader buildingsId={buildingsId}
                                    building={building}
                                    buildings={buildings}
                                    btnSyncDisabled={btnSyncDisabled}
                                    methodGetAsync={taxesGetAsync}
                                    processType={0}
                                    headerSectionValues={{}}
                                    showLoading={showLoading?.building}
                                    languageObj={languageObj} />

                                {/*Taxes*/}
                                <div className='card card-outline card-primary shadow-lg'>
                                    <LoadingSection alt='loadingSection'
                                        className={reactHtml?.overlay?.darkTextWhite}
                                        showText={true}
                                        text={messages?.processing?.[languageObj?.id]}
                                        height={25}
                                        hidden={!showLoading?.taxes}
                                        width={25}
                                        languageId={languageObj?.id}
                                        subMethod={currentMethod} />

                                    {/*header*/}
                                    <div className='card-header'>
                                        <h6 className='card-title'>
                                            <img alt={labels?.taxes?.[languageObj?.id]} style={styles?.cardHeaderLogo} src={globalSettings?.images?.taxesLogo}></img> - {labels?.taxes?.[languageObj?.id]}
                                        </h6>
                                        <div className='card-tools'>
                                            <button type='button' className='btn btn-tool' data-card-widget='collapse'>
                                                <i className={icons?.minus}></i>
                                            </button>
                                        </div>
                                    </div> {/*card header*/}

                                    {/*body*/}
                                    <div className='card-body'>

                                        <div className='row'>
                                            {/* {!showLoading ? */}
                                            <div className='col-md-12'>
                                                {/* {showData ? */}
                                                {/* <div> */}
                                                <button id={controls?.dataTables?.taxes?.buttons?.add?.id}
                                                    className={controls?.dataTables?.taxes?.buttons?.add?.className}
                                                    disabled={btnAddDisable}
                                                    tooltip='tooltip'
                                                    title={labels?.add?.[languageObj?.id]}
                                                    onClick={(e) => taxAddDetailsEditGetAsync({ e: e, id: '', description: '', rowIndex: 0, processType: 0, subMethod: 'btn - taxAdd', })}>
                                                    <i id={controls?.dataTables?.taxes?.icons?.add?.id} className={controls?.dataTables?.taxes?.icons?.add?.className} /> <span id={controls?.dataTables?.taxes?.spinners?.add?.id} className='' aria-hidden='true'></span>
                                                </button>

                                                <div className={globalSettings?.html?.dataTables?.formats?.tableResponsiveSm}>
                                                    <table id={dtTaxesId} className={globalSettings?.html?.dataTables?.formats?.smStripedBordered}></table>
                                                </div>
                                                {/* </div> */}
                                                {/* : */}
                                                {/* <div></div> */}
                                                {/* } */}
                                            </div>
                                            {/* : */}
                                            {/* <CssfxLoading type={sweetAlert2?.CssfxLoading?.circularProgress}
                                                    width={40}
                                                    height={40}
                                                    color={colors?.infoColorExp}
                                                    msgText={messages?.processing?.[languageObj?.id]}
                                                    msgOrientation='text-center'
                                                    msgTextMuted={true} /> */}
                                            {/* } */}
                                        </div>

                                    </div>

                                    {/*footer*/}
                                    {/* <div className='card-footer'>
                                    </div> */}

                                </div>

                            </div>
                        </div>

                    </div>
                </section>

            </div>

            {showModal ?
                <TaxAddDetailsEdit $={$}
                    auth={auth}
                    userRole={userRole}
                    tax={tax}
                    setTax={setTax}
                    dtId={dtTaxesId}
                    dtRowIndex={dtTaxesRowIndex}
                    showModal={showModal}
                    setShowModal={setShowModal}
                    processType={processType}
                    setProcessType={setProcessType}
                    languageObj={languageObj} />
                :
                <></>
            }
        </div>
    )
}